import Colors from '../../../../assets/Colors'

export const stopAutoDispatchStyles = {
    dialogTitle: {
        color: Colors.napaBlue,
        fontSize: '28px',
        fontWeight: 700,
        paddingBottom: 1
    },
    closeIcon: {
        position: 'absolute',
        right: 8,
        top: 16,
        color: 'black',
    },
    closeIconImg: {
        fontSize: '36px'
    },
    dialogActions: {
        flexDirection: 'column',
        alignItems: 'stretch', '& > :not(:first-of-type)': { marginLeft: 0 }
    },
    cancelButton: {
        marginBottom: '8px',
        width: '100%',
        textTransform: 'none',
        fontWeight: '700',
        fontSize: '16px',
        height: '44px',
        backgroundColor: 'white'
    },
    stopAutoDispatchButton: {
        width: '100%',
        fontWeight: '700',
        fontSize: '16px',
        height: '44px',
        textTransform: 'none'
    },
    dialogSize: {
        '.MuiDialog-paper': { maxWidth: '400px' }
    },
    dialogContentText: {
        marginBottom: '13px'
    }
}